import http from "@/services/http";
import {ref} from 'vue';
import {useAuth} from "@/services/auth.js";

export const orcamentos = () => {
  const auth = useAuth();

  async function list(page = 1, status = null) {
    let retorno;
    try {
      let url = '/budgets?page=' + page;
      if (status) url += '&status=' + status;
      const {data} = await http.get(url, auth.getBearer());
      retorno = data;
    } catch (error) {
      console.log(error?.response?.data);
    }
    return retorno;
  }

  // Mensagem real de erro (ex.: item que não pertence à loja) — a tela
  // de criação precisa mostrar o motivo, não só saber que falhou.
  const lastErrorMessage = ref(null);

  async function create(payload) {
    try {
      const { data } = await http.post('/budgets', payload, auth.getBearer());
      lastErrorMessage.value = null;
      return data.data;
    } catch (error) {
      lastErrorMessage.value = error?.response?.data?.message ?? null;
      console.log(error?.response?.data);
      return false;
    }
  }

  async function show(id) {
    try {
      const {data} = await http.get('/budgets/' + id, auth.getBearer());
      return data;
    } catch (error) {
      console.log(error?.response?.data);
      return null;
    }
  }

  // Aprovar já converte o orçamento em venda de verdade (baixa estoque) —
  // por isso pede a forma de pagamento, igual o fechamento de uma venda.
  // `paymentMode` 'half' paga metade agora na forma escolhida (não pode
  // ser fiado) e empurra a outra metade pra conta do cliente.
  async function approve(id, paymentMethodId, paymentMode = 'full') {
    try {
      await http.post('/budgets/' + id + '/approve', {
        payment_method_id: paymentMethodId,
        payment_mode: paymentMode,
      }, auth.getBearer());
      return true;
    } catch (error) {
      lastErrorMessage.value = error?.response?.data?.message ?? null;
      console.log(error?.response?.data);
      return false;
    }
  }

  async function reject(id) {
    try {
      await http.post('/budgets/' + id + '/reject', {}, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  async function deleteItem(id) {
    try {
      await http.delete('/budgets/' + id, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  return {list, create, show, approve, reject, deleteItem, lastErrorMessage}
}
